export const messages = {
  en: {
    couponMarket: {
      search: {
        placeholder: 'Please enter coupon name',
      },
      price: 'Price',
      buy: 'Buy',
      fetchSupplierError: 'Failed to fetch supplier list',
      fetchCouponError: 'Failed to fetch coupon list'
    }
  },
  zh: {
    couponMarket: {
      search: {
        placeholder: '请输入优惠券名称',
      },
      price: '售价',
      buy: '购买',
      fetchSupplierError: '获取供应商列表失败',
fetchCouponError: '獲取優惠券列表失敗'
    }
  },
  'zh-TW': {
    couponMarket: {
      search: {
        placeholder: '請輸入優惠券名稱',
      },
      price: '售價',
      buy: '購買',
      fetchSupplierError: '獲取供應商列表失敗',
      fetchCouponError: '獲取優惠券列表失敗'
    }
  }
}